<template>
  <div class="recommends-block">
    <h2 class="recommends-title">
      {{ title }}
    </h2>
    <agile v-if="recomendItems" ref="thumbnails" class="thumbnails" :options="options">
      <div
        v-for="(slide, index) in recomendItems"
        :key="index"
        class="slide slide--thumbniail"
        :class="`slide--${index}`"
      >
        <CatalogItemSmall
          :item="slide"
          :category="slide.categories && slide.categories.length > 0 ? slide.categories[0] : null"
          :product-scheme="false"
        />
      </div>
    </agile>
  </div>
</template>

<script>
import CatalogItemSmall from '@/components/CatalogItemSmall'

export default {
  name: 'Recommends',

  components: {
    CatalogItemSmall
  },

  props: {
    recomendItems: {
      type: Array,
      default: () => []
    },

    title: {
      type: String,
      default: 'Вам может понравиться'
    }
  },

  data () {
    return {
      options: {
        autoplay: false,
        centerMode: true,
        dots: false,
        navButtons: true,
        slidesToShow: 2,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 5
            }
          }
        ]
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss">
.recommends-block {
  margin-top: 45px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;

  .badge__new{
    width: 30px;
    height: 30px;
    background-size: cover;
    background-position: 0 -32px;
  }

  .badge__hit{
    width: 30px;
    height: 30px;
    background-size: cover;
    background-position: 0 0px;
  }

  .badge__sale{
    width: 30px;
    height: 30px;
    background-size: cover;
    background-position: 0 -66px;
  }
}

.agile {
  &__list {
    margin: 0 -3px;
  }

  &__slide {
    padding: 3px;
  }

  &__actions {
    position: relative;
    top: -20px;
  }

  &__nav-button {
    font-size: 30px;
  }
}

h2.recommends-title {
  font: bold 20px/22px 'ProxyB', Arial, Helvetica, sans-serif !important;
  margin-bottom: 12px;
}

@media only screen and (max-width: 900px) {
  .recommends-title:before,
  .recommends-title:after {
    display: none;
  }

  .recommends-block {
    padding: 0 10px;
    width: 100%;
  }
}
</style>
